<template>
  <ButtonBase
    :buttonText="buttonText"
    :class="{ 'button-toggle': !disabled, 'button-active': active }"
    :disabled="disabled"
    :iconLeft="iconLeft"
    :iconRight="iconRight"
    :size="size"
    :whiteContent="hover || active"
    @onClicked="onClicked"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
  ></ButtonBase>
</template>
<script setup lang="ts">
import ButtonBase from '@/design-system/atoms/buttons/ButtonBase.vue'
import { ref } from 'vue'

type Emits = {
  (e: 'onClicked')
}

type Props = {
  buttonText?: string
  disabled?: boolean
  iconLeft?: string
  iconRight?: string
  size?: string
  active?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  buttonText: '',
  disabled: false,
  iconLeft: '',
  iconRight: '',
  size: 'medium',
  active: false
})

const emits = defineEmits<Emits>()

const hover = ref(false)

function onClicked() {
  if (!props.disabled) {
    emits('onClicked')
  }
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
.button-toggle {
  &:hover {
    color: variables.$color-pure-white;
    background: variables.$color-primary-dark;
  }
}

.button-active {
  background: variables.$color-primary;
  color: variables.$color-pure-white;
}
</style>
